export default {
  setUser(state, user) {
    state.user = user;
  },

  setAdminPanel(state, bool) {
    state.adminPanel = bool;
  },

  SET_COMPANY_LICENCE(state, licence) {
    state.companyLicence = licence;
  },

  SET_SELECTED_REPORT_LANGUAGES(state, languages) {
    state.selectedReportLanguages = languages;
  },

  SET_NAVBAR_OPEN(state, bool) {
    state.navbarOpen = bool;
  },

  SET_QUEUED_JOBS(state, jobs) {
    state.queued_jobs = jobs;
  },

  SET_FULFILLED_JOBS(state, jobs) {
    state.fulfilled_jobs = jobs;
  },

  SET_APP_STATE(state, app_state) {
    state.app_state = app_state;
  },
};
